module.exports = __webpack_public_path__ + "img/header-background-ar.bea0483b.png";